export default __webpack_public_path__ + "static/media/error.6aed576b.svg";